import { useEffect, useState } from "react";
import { CustomSelect, DropdownOptions, getNewDayAndHourDataValues } from "../../../../../../_helpers/Helpers";

export function DayAndHourForm({
  index,
  hour,
  courses,
  sections,
  teachers,
  editTable,
  dayAndHourData,
  values,
  setDayAndHourDataValues
}) {
  const [firstId, setFirstId] = useState();
  const [secondId, setSecondId] = useState();
  const courseOptions = DropdownOptions.concat(courses);
  const sectionOptions = DropdownOptions.concat(sections);
  const teacherOptions = DropdownOptions.concat(teachers);
  const dataInThisDayAndHour = dayAndHourData.find(data => data.day === index + 1 && data.hour === hour);
  const firstOptions = editTable === "sinif-duzenle" ? courseOptions : editTable === "ogretmen-duzenle" ? sectionOptions : [];
  const secondOptions = editTable === "sinif-duzenle" ? teacherOptions : editTable === "ogretmen-duzenle" ? courseOptions : [];
  
  useEffect(() => {
    setFirstId(dataInThisDayAndHour?.firstId);
    setSecondId(dataInThisDayAndHour?.secondId);
  }, [dataInThisDayAndHour]);

  return (
    <td className="text-center">
      <CustomSelect
        options={firstOptions}
        value={firstId}
        onChange={option => {
          const newValue = {
            day: index + 1,
            hour: hour,
            firstId: option.value,
            secondId: secondId
          };
          const newValues = getNewDayAndHourDataValues(values, newValue);
          setDayAndHourDataValues(newValues);
          setFirstId(option.value);
        }}
      />
      <br />
      <CustomSelect
        options={secondOptions}
        value={secondId}
        onChange={option => {
          const newValue = {
            day: index + 1,
            hour: hour,
            firstId: firstId,
            secondId: option.value
          };
          const newValues = getNewDayAndHourDataValues(values, newValue);
          setDayAndHourDataValues(newValues);
          setSecondId(option.value);
        }}
      />
    </td>
  )
}